import axios from 'axios';
import Qs from 'qs';
import { THEATRE_ACL_BASE_URL } from '../config';
import { getAccessToken } from '../util/helper';

const qwTheatreACL = axios.create({
  baseURL: THEATRE_ACL_BASE_URL,
  responseType: 'json',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${getAccessToken()}`,
  },
  paramsSerializer(params) {
    return Qs.stringify(params, { arrayFormat: 'brackets' });
  },
});

export default qwTheatreACL;
